const Checkbox = ({ className, name, checked, onChange, disabled, children }) => {

    const classes = [
        'is-checkradio',
        className
    ].join(' ');

    return (
        <div className="field">
            <input className={classes}
                id={name} type="checkbox"
                name={name} onChange={onChange}
                checked={checked}
                disabled={disabled} />
            <label htmlFor={name}>{children}</label>
        </div>
    );
};

export { Checkbox };
